import {useTheme} from "../../../common/ProjectThemeProvider";
import React, {useEffect, useState} from 'react';
import {AppInterface, RecordsPagination} from "../../index";
import {GenRouteUrls, Keys, ModuleFieldsData, Modules, ReqUrls} from "../../config/AppConfig";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    extractHtmlInnerText,
    getArrLen,
    getDefStr,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    limitStringWords,
    setTabTitle
} from "../../../common/fusion-ui/utils/ReactUtils";
import {formatDateValue, getAllocatedModuleName, printError, printLog, sendRequest} from "../../utils/AppUtils";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {Anchor, Flexbox, Label, LoadingSection, NullMsgLabel, PolyStateToggle, Section} from "../../../common/fusion-ui"
import {CssVariant, DefStrNA, Messages} from 'common/fusion-ui/config/FusionConfig';
import {useConfig} from "../../context/ConfigProvider";

const MyParticipationsPage = React.memo(({}) => {
    const TAG = "MyParticipationsPage";

    const moduleName = Modules.MyParticipations;

    const SectionTypes = {
        wm: {id: 'wm', label: getAllocatedModuleName(Modules.WebMeeting) + ' Topics'},
        df: {id: 'df', label: getAllocatedModuleName(Modules.DiscussionForum) + ' Topics'},
        srv: {id: 'srv', label: getAllocatedModuleName(Modules.Survey) + ' Topics'},
    };

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, updateConfig} = useConfig();

    const module_wm = Modules.WebMeeting;
    const module_df = Modules.DiscussionForum;
    const module_srv = Modules.Survey;

    const mf_wm = ModuleFieldsData[module_wm];
    const mf_df = ModuleFieldsData[module_df];
    const mf_srv = ModuleFieldsData[module_srv];

    const PAGINATION_RECORD_LIMITS = [8, 12, 16, 20];
    const DEF_PGNTN_RECORD_LIMIT = PAGINATION_RECORD_LIMITS[0];
    const DEF_PGNTN_START_INDEX = 1;
    const DEF_TAB_ID = SectionTypes.wm.id;

    const Fields = {
        currSelectedTabId: 'currSelectedTabId',

        isDataFetched: 'isDataFetched',

        isDataLoading_wm: 'isDataLoading_wm',
        isDataFound_wm: 'isDataFound_wm',
        dataLoadingMsg_wm: 'dataLoadingMsg_wm',

        isDataLoading_df: 'isDataLoading_df',
        isDataFound_df: 'isDataFound_df',
        dataLoadingMsg_df: 'dataLoadingMsg_df',

        isDataLoading_srv: 'isDataLoading_srv',
        isDataFound_srv: 'isDataFound_srv',
        dataLoadingMsg_srv: 'dataLoadingMsg_srv',

        wmRecordList: 'wmRecordList',
        forumRecordList: 'forumRecordList',
        surveyRecordList: 'surveyRecordList',

        pagination_currPageNum_wm: 'pagination_currPageNum_wm',
        pagination_currPageLimit_wm: 'pagination_currPageLimit_wm',

        pagination_currPageNum_df: 'pagination_currPageNum_df',
        pagination_currPageLimit_df: 'pagination_currPageLimit_df',

        pagination_currPageNum_srv: 'pagination_currPageNum_srv',
        pagination_currPageLimit_srv: 'pagination_currPageLimit_srv',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        setTabTitle(getAllocatedModuleName(moduleName));
        updateConfig(Keys.config_ShowTabBar, true);
        updateConfig(Keys.config_TabBarTab, -1);
        updateConfig(Keys.tracker_currPageModule, moduleName);
        updateConfig(Keys.tracker_currPageTag, TAG);
        if (!checkNullStr(getField(Fields.pagination_currPageNum_wm))) {
            updateField(Fields.pagination_currPageNum_wm, DEF_PGNTN_START_INDEX);
            updateField(Fields.pagination_currPageLimit_wm, DEF_PGNTN_RECORD_LIMIT);

            updateField(Fields.pagination_currPageNum_df, DEF_PGNTN_START_INDEX);
            updateField(Fields.pagination_currPageLimit_df, DEF_PGNTN_RECORD_LIMIT);

            updateField(Fields.pagination_currPageNum_srv, DEF_PGNTN_START_INDEX);
            updateField(Fields.pagination_currPageLimit_srv, DEF_PGNTN_RECORD_LIMIT);

            updateField(Fields.currSelectedTabId, DEF_TAB_ID);
        }
        fetchPageData();
    }, []);

    return (<>
        <AppInterface label={moduleName}>
            <div className={'mb-1 m-0 w-100 h-100x bg-dangerx'}>
                <div className={'m-0 p-0 mt-2 w-100 h-100x position-relative bg-infox'}>
                    <Flexbox className={'px-2x'} justifyAt={'start'}>
                        {/*message-type toggle*/}
                        <PolyStateToggle
                            className={''}
                            variant={'primary'}
                            rippleVariant={'light'}
                            reverseVariant={'white'}
                            fsVariant={'sm'}
                            disabled={isFieldTrue(Fields.isDataLoading_wm)}
                            defOption={Object.values(SectionTypes).findIndex(item => item.id == getField(Fields.currSelectedTabId))}>
                            {Object.values(SectionTypes).map((item, index) => {
                                return checkNullJson(item) && {
                                    text: item.label,
                                    onClick: ((text, index) => {
                                        // toast(`${text} tab clicked`);
                                        updateField(Fields.currSelectedTabId, item.id);
                                        // handleSectionTypeChange(item.label,item.id);
                                    })
                                }
                            })}
                        </PolyStateToggle>
                    </Flexbox>

                    {/* wm */}
                    {getField(Fields.currSelectedTabId) == SectionTypes.wm.id && createWmSection()}

                    {/* df */}
                    {getField(Fields.currSelectedTabId) == SectionTypes.df.id && createDfSection()}

                    {/* src */}
                    {getField(Fields.currSelectedTabId) == SectionTypes.srv.id && createSrvSection()}
                </div>
            </div>
        </AppInterface>
    </>)

    //======================UI Functions start=====================
    function createWmSection() {
        return <div className={'mt-2 pt-1'}>
            {createLoadingPanel(Fields.isDataFound_wm, Fields.isDataLoading_wm, Fields.dataLoadingMsg_wm)}

            {(!isFieldTrue(Fields.isDataLoading_wm) && isFieldTrue(Fields.isDataFound_wm)) &&
                <div>
                    {/*record-list*/}
                    <div>
                        {(checkNullArr(getWmRecordListToRender()))
                            ? getWmRecordListToRender().map((item, index) => {
                                const recordId = getJsonValue(item, mf_wm.recordId.column);
                                return (checkNullJson(item)) && <div
                                    key={index + getJsonValue(item, mf_wm.title.column)}
                                    className={'bg-infox m-0 p-0'}>
                                    <Section
                                        className={'m-0 p-2 h-auto mb-3 app-section hover'}
                                        position={'relative'}
                                        borderless={false}
                                        roundedVariant={4}
                                        borderColor={theme.text20}
                                        contentClassName={'px-1 h-100'}>
                                        <div>
                                            {/*title-link*/}
                                            <div className={'d-flex w-auto'}>
                                           <span>
                                                <Anchor
                                                    className={'fw-semi-bold text-wrap text-break'}
                                                    href={`${GenRouteUrls.wm_internalPage}${recordId}`}>
                                                {getJsonValue(item, mf_wm.title.column)}
                                            </Anchor>
                                           </span>
                                            </div>

                                            {/*outline*/}
                                            <div>
                                                <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                    <span>{" "}{limitStringWords(getJsonValue(item, mf_wm.outline.column, DefStrNA), 100, " ", '...')}</span>
                                                </Label>
                                            </div>

                                            {/*presenter*/}
                                            <div>
                                                <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                    <span className={'fw-semi-bold'}>{mf_wm.presenter.titleAlt}: </span>
                                                    <span>{" "}{getJsonValue(item, mf_wm.presenter.column, DefStrNA)}</span>
                                                </Label>
                                            </div>

                                            {/*date*/}
                                            <div>
                                                <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                    <span className={'fw-semi-bold'}>{mf_wm.date.titleAlt}: </span>
                                                    <span className={'text-nowrap'}>{" "}{formatDateValue(getJsonValue(item, mf_wm.date.column, DefStrNA))}</span>
                                                </Label>
                                            </div>
                                        </div>
                                    </Section>
                                </div>
                            })
                            : <NullMsgLabel>{getDefStr(getField(Fields.dataLoadingMsg_wm), "No record found!")}</NullMsgLabel>}
                    </div>

                    {/*pagination*/}
                    {createSectionPagination({
                        moduleName: Modules.WebMeeting,
                        totalRecordsToRender: getArrLen(getWmRecordListToRender()),
                        totalRecordsLen: getArrLen(getWmRecordList()),
                        currPageRecordLimitKey: Fields.pagination_currPageLimit_wm,
                        currPageNumKey: Fields.pagination_currPageNum_wm,
                    })}
                </div>}
        </div>
    }

    function createDfSection() {
        return <div className={'mt-2 pt-1'}>
            {createLoadingPanel(Fields.isDataFound_df, Fields.isDataLoading_df, Fields.dataLoadingMsg_df)}

            {(!isFieldTrue(Fields.isDataLoading_df) && isFieldTrue(Fields.isDataFound_df)) &&
                <div>
                    {/*record-list*/}
                    <div>
                        {(checkNullArr(getDfRecordListToRender()))
                            ? getDfRecordListToRender().map((item, index) => {
                                const recordId = getJsonValue(item, mf_df.recordId.column);
                                return <Section
                                    key={index + getJsonValue(item, mf_df.title.column, DefStrNA)}
                                    className={'m-0 p-2 h-100 mb-3 app-section hover'}
                                    position={'relative'}
                                    borderless={false}
                                    roundedVariant={4}
                                    borderColor={theme.text20}
                                    contentClassName={'px-1'}>
                                    <div>
                                        {/*title-bar & icons*/}
                                        <Flexbox className={'w-100'}
                                                 justifyAt={'between'} justifyAtSm={'start'}
                                                 alignAt={'start'} alignAtSm={'start'}
                                                 wrap={'wrap'}
                                        >
                                            {/*title-link*/}
                                            <Anchor
                                                className={'fw-semi-bold text-wrap'}
                                                href={`${GenRouteUrls.df_internalPage}${recordId}`}>
                                                {(getJsonValue(item, mf_df.title.column))}
                                            </Anchor>

                                            {/* comments & total views  */}
                                            <Flexbox className={''}
                                                     justifyAt={'end'} justifyAtSm={'start'}
                                                     alignAt={'center'} alignAtSm={'start'}
                                            >
                                                {/* my comments */}
                                                <Label
                                                    className={'m-0 p-0 mx-1 px-2 py-0 al-center rounded-10 d-flex flex-nowrap fd-row jc-center al-center'}
                                                    iconClass={'bi bi-chat fs-sm pe-1'}
                                                    color={theme.text90}
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    tooltip={mf_df.myComment.title}
                                                    style={{
                                                        border: `1px solid ${theme.text20}`, height: '22px'
                                                    }}
                                                >
                                                    {getJsonValue(item, mf_df.myComment.column, 0)}
                                                </Label>

                                                {/* all comments */}
                                                <Label
                                                    className={'m-0 p-0 mx-1 px-2 py-0 al-center rounded-10 d-flex flex-nowrap fd-row jc-center al-center'}
                                                    iconClass={'fa fa-comments-o fs-sm pe-1'}
                                                    color={theme.text90}
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    tooltip={mf_df.comments.title}
                                                    style={{
                                                        border: `1px solid ${theme.text20}`, height: '22px'
                                                    }}
                                                >
                                                    {getJsonValue(item, mf_df.comments.column, 0)}
                                                </Label>

                                                {/* totalViews */}
                                                <Label
                                                    className={'m-0 p-0 mx-1 px-2 py-0 al-center rounded-10 d-flex flex-nowrap fd-row jc-center al-center'}
                                                    iconClass={'bi bi-eye fs-sm pe-1'}
                                                    color={theme.text90}
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    tooltip={mf_df.totalViews.title}
                                                    style={{
                                                        border: `1px solid ${theme.text20}`, height: '22px'
                                                    }}
                                                >
                                                    {getJsonValue(item, mf_df.totalViews.column, 0)}
                                                </Label>
                                            </Flexbox>
                                        </Flexbox>

                                        <div className={'d-flex flex-wrap fd-column w-100'}>
                                            {/* introduction*/}
                                            <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                <span className={'fw-semi-bold'}>{mf_df.desc.titleAlt2}: </span>
                                                <span>{" "}{limitStringWords(extractHtmlInnerText(getJsonValue(item, mf_df.desc.column), DefStrNA), 120, ' ', '...')}</span>
                                            </Label>

                                            {/*date*/}
                                            <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                                <span className={'fw-semi-bold'}>{mf_df.endDate.titleAlt}: </span>
                                                <span className={'text-nowrap'}>{" "}{formatDateValue(getJsonValue(item, mf_df.endDate.column), DefStrNA)}</span>
                                            </Label>
                                        </div>
                                    </div>
                                </Section>
                            })
                            : <NullMsgLabel>{getDefStr(getField(Fields.dataLoadingMsg_df), "No record found!")}</NullMsgLabel>}
                    </div>

                    {/*pagination*/}
                    {createSectionPagination({
                        moduleName: Modules.DiscussionForum,
                        totalRecordsToRender: getArrLen(getDfRecordListToRender()),
                        totalRecordsLen: getArrLen(getDfRecordList()),
                        currPageRecordLimitKey: Fields.pagination_currPageLimit_df,
                        currPageNumKey: Fields.pagination_currPageNum_df,
                    })}
                </div>}
        </div>
    }

    function createSrvSection() {
        return <div className={'mt-2 pt-1'}>
            {createLoadingPanel(Fields.isDataFound_srv, Fields.isDataLoading_srv, Fields.dataLoadingMsg_srv)}

            {(!isFieldTrue(Fields.isDataLoading_srv) && isFieldTrue(Fields.isDataFound_srv)) &&
                <div>
                    {/*record-list*/}
                    <div>
                        {(checkNullArr(getSrvRecordListToRender()))
                            ? getSrvRecordListToRender().map((item, index) => {
                                const recordId = getJsonValue(item, mf_srv.recordId.column)
                                return <Section
                                    key={index + getJsonValue(item, mf_srv.title.column)}
                                    className={'m-0 p-2 h-100 mb-3 app-section hover'}
                                    position={'relative'}
                                    borderless={false}
                                    roundedVariant={4}
                                    borderColor={theme.text20}
                                    contentClassName={'px-1'}>
                                    {/*title-link*/}
                                    <div className={'w-auto d-flex'}>
                                        <Anchor
                                            wrapperClassName={'w-auto'}
                                            className={'fw-semi-bold text-wrap'}
                                            href={`${GenRouteUrls.survey_internalPage}${recordId}`}>
                                            {(getJsonValue(item, mf_srv.title.column))}
                                        </Anchor>
                                    </div>
                                    {/*introduction*/}
                                    <div>
                                        <Label className={'m-0 p-0 text-wrap'} color={theme.text} textAt={'start'}>
                                            <span className={'fw-semi-bold'}>{mf_srv.introduction.title}: </span>
                                            <span>{" "}{getDefStr(extractHtmlInnerText(getJsonValue(item, mf_srv.introduction.column), DefStrNA), getJsonValue(item, mf_srv.introduction.column, DefStrNA))}</span>
                                        </Label>
                                    </div>

                                    {/*endDate*/}
                                    <div>
                                        <Label className={'m-0 p-0 text-nowrap'} color={theme.text} textAt={'start'}>
                                            <span className={'fw-semi-bold'}>{mf_srv.endDate.title}: </span>
                                            <span className={'text-nowrap'}>{" "}{formatDateValue(getJsonValue(item, mf_srv.endDate.column), DefStrNA)}</span>
                                        </Label>
                                    </div>


                                    {/*endDate & controls*/}
                                    <Flexbox className={''} justifyAt={'between'} justifyAtMd={'start'}
                                             wrap={'wrap'}>

                                    </Flexbox>
                                </Section>
                            })
                            : <NullMsgLabel>{getDefStr(getField(Fields.dataLoadingMsg_srv), "No record found!")}</NullMsgLabel>}
                    </div>

                    {/*pagination*/}
                    {createSectionPagination({
                        moduleName: Modules.Survey,
                        totalRecordsToRender: getArrLen(getSrvRecordListToRender()),
                        totalRecordsLen: getArrLen(getSrvRecordList()),
                        currPageRecordLimitKey: Fields.pagination_currPageLimit_srv,
                        currPageNumKey: Fields.pagination_currPageNum_srv,
                    })}
                </div>}
        </div>
    }

    function createLoadingPanel(dataFoundKey, loadingKey, msgKey) {
        return <LoadingSection
            labelClassName={'m-2 w-100 fs-normal'}
            heightClass={75}
            color={theme.text70}
            success={isFieldTrue(dataFoundKey)}
            loading={isFieldTrue(loadingKey)}
            msg={getField(msgKey)}
        />
    }

    function createSectionPagination({
                                         moduleName,
                                         totalRecordsToRender = 0,
                                         totalRecordsLen = 0,
                                         currPageRecordLimitKey,
                                         currPageNumKey,
                                     }) {
        return <RecordsPagination
            id={TAG + moduleName}
            totalRecords={totalRecordsLen}
            totalRecordsToRender={totalRecordsToRender}
            recordLimits={PAGINATION_RECORD_LIMITS}
            onPageChange={(e, newPageIndex) => {
                // log('RecordsPagination.onLimitChange.moduleName:', moduleName,'newPageIndex:',newPageIndex);
                updateField(currPageNumKey, newPageIndex);
            }}
            onLimitChange={(newLimit, newPageIndex) => {
                // log('RecordsPagination.onLimitChange.moduleName:', moduleName,'newPageIndex:',newPageIndex,'newLimit:',newLimit);
                updateField(currPageRecordLimitKey, newLimit);
                updateField(currPageNumKey, newPageIndex);
            }}
        />
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    async function fetchPageData() {
        const fun = 'fetchPageData:';
        if (!isFieldTrue(Fields.isDataFetched)) {
            updateField(Fields.isDataFetched, true);

            const data = await Promise.all([
                //wm
                fetchSingleModuleData({
                    moduleName: module_wm,
                    reqUrl: ReqUrls.wm__mainPage_fetch_recordList,
                    listKey: Fields.wmRecordList,
                    loadingKey: Fields.isDataLoading_wm,
                    dataFoundKey: Fields.isDataFound_wm,
                    msgKey: Fields.dataLoadingMsg_wm,
                }),
                //df
                fetchSingleModuleData({
                    moduleName: module_df,
                    reqUrl: ReqUrls.df__mainPage_fetch_recordList,
                    listKey: Fields.forumRecordList,
                    loadingKey: Fields.isDataLoading_df,
                    dataFoundKey: Fields.isDataFound_df,
                    msgKey: Fields.dataLoadingMsg_df,
                }),
                //srv
                fetchSingleModuleData({
                    moduleName: module_srv,
                    reqUrl: ReqUrls.survey__mainPage_fetch_recordList,
                    listKey: Fields.surveyRecordList,
                    loadingKey: Fields.isDataLoading_srv,
                    dataFoundKey: Fields.isDataFound_srv,
                    msgKey: Fields.dataLoadingMsg_srv,
                }),
            ]);
        }
    }

    async function fetchSingleModuleData({moduleName, reqUrl, listKey, loadingKey, dataFoundKey, msgKey}) {
        const fun = 'fetchSingleModuleData:';
        try {
            updateField(dataFoundKey, false);
            updateField(loadingKey, true);
            updateField(msgKey, '');
            sendRequest({
                reqUrl: reqUrl,
                onFetched: ((fetchedData) => {
                    // log(fun, 'moduleName:', moduleName,  'fetchedData:', fetchedData);

                    const recordList = getJsonValueFromNestedKeys(fetchedData, ['data', 'recordList'], []);
                    log(fun, 'moduleName:', moduleName, 'fetchedData.recordList:', recordList);

                    const success = checkNullArr(recordList);
                    updateField(dataFoundKey, success);
                    if (success) {
                        // toast(`Successfully fetched data for ${moduleName}.`, CssVariant.success)
                        updateField(listKey, recordList);
                    } else {
                        updateField(msgKey, Messages.noDataFound);
                        // toast(`Data not found for ${moduleName}!`, CssVariant.danger);
                    }
                    updateField(loadingKey, false);
                }),
                onError: ((error) => {
                    logErr(fun, error);
                    toast(`Couldn't load data for ${moduleName}!`, CssVariant.danger);
                    updateField(loadingKey, false);
                    updateField(dataFoundKey, false);
                    updateField(msgKey, Messages.fetchError);
                }),
            });
        } catch (error) {
            logErr(fun, error);
            toast(`Couldn't load data for ${moduleName}!`, CssVariant.danger);
            updateField(loadingKey, false);
            updateField(dataFoundKey, false);
            updateField(msgKey, Messages.fetchError);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================

    function getWmRecordList() {
        return checkNullArr(getField(Fields.wmRecordList)) ? getField(Fields.wmRecordList) : [];
    }

    function getWmRecordListToRender() {
        return getWmRecordList().slice((getField(Fields.pagination_currPageNum_wm) - 1) * getField(Fields.pagination_currPageLimit_wm), getField(Fields.pagination_currPageNum_wm) * getField(Fields.pagination_currPageLimit_wm));
    }

    function getDfRecordList() {
        return checkNullArr(getField(Fields.forumRecordList)) ? getField(Fields.forumRecordList) : [];
    }

    function getDfRecordListToRender() {
        return getDfRecordList().slice((getField(Fields.pagination_currPageNum_df) - 1) * getField(Fields.pagination_currPageLimit_df), getField(Fields.pagination_currPageNum_df) * getField(Fields.pagination_currPageLimit_df));
    }

    function getSrvRecordList() {
        return checkNullArr(getField(Fields.surveyRecordList)) ? getField(Fields.surveyRecordList) : [];
    }

    function getSrvRecordListToRender() {
        return getSrvRecordList().slice((getField(Fields.pagination_currPageNum_srv) - 1) * getField(Fields.pagination_currPageLimit_srv), getField(Fields.pagination_currPageNum_srv) * getField(Fields.pagination_currPageLimit_srv));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default MyParticipationsPage;
